export const deliveryLocationTypes = ['public', 'private'] as const;
export type DeliveryLocationType = (typeof deliveryLocationTypes)[number];
export const deliveryLocationTypeMap = {
  public: 'Public Property',
  private: 'Private Property',
} as const;

export const discountTypes = ['percent', 'dollars'] as const;
export type CartDiscountType = (typeof discountTypes)[number];
export interface Discount {
  type: CartDiscountType;
  percentage: number;
  amountInCents: number;
  appliedRuleId?: string; // Optional for manual admin discounts
  discountCode?: string; // Optional for manual admin discounts
}
